import { ref } from 'vue';
import { AxiosError } from 'axios';

export default () => {
  const _error = ref();

  const clearError = (): void => {
    _error.value = undefined;
  };

  const handleError = (targetError: unknown, fallback: string): void => {
    let message = fallback;

    if (targetError instanceof AxiosError) {
      if (targetError.response?.data?.message) {
        message = targetError.response?.data?.message;
      }
    }

    _error.value = message;
  };

  return {
    error: _error,
    clearError,
    handleError,
  };
};
